import { render, staticRenderFns } from "./bigNum.vue?vue&type=template&id=2bb4ec7a&scoped=true&"
import script from "./bigNum.vue?vue&type=script&lang=js&"
export * from "./bigNum.vue?vue&type=script&lang=js&"
import style0 from "./bigNum.vue?vue&type=style&index=0&id=2bb4ec7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb4ec7a",
  null
  
)

export default component.exports